<main class="px-5 py-2 __page-container __page-container-fixed shadow-xl" [@moveContainer]="animationState">
  <section class="__top-header h-30 border-b border-gray-300 p-3 flex items-center justify-between">
    <div class="text-lg font-bold tracking-wide">
      <div>{{title}}</div>
    </div>
    <button (click)="back()" type="button" class="bg-white rounded-md p-2 inline-flex items-center justify-center text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500">
      <span class="sr-only">Close menu</span>
      <svg class="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
      </svg>
    </button>
  </section>

  <div class="content">
    <ng-content></ng-content>
  </div>

</main>

<div class="bg-wwhite" (click)="back()"></div>
